<template>
  <div class="restaurant-card-wrapper">
    <div class="restaurant-card-header">
      <VImage
        v-if="restaurant.logo"
        :src="restaurant.logo"
        class="restaurant-card-logo"
      />
      <VImage v-else :src="defaultLogo" class="restaurant-card-default-logo" />
      <div :style="{ width: '100%' }">
        <div class="restaurant-card-header-row">
          <span class="restaurant-card-title">{{ restaurant.name }}</span>
          <span class="restaurant-info-item">{{
            getType(restaurant.cfTypeId)
          }}</span>
        </div>
      </div>
    </div>
    <VStars is-number :value="restaurant.rating" class="stars" />
    <div class="restaurant-card-column _right">
      <div v-if="restaurant.averageCheck" class="restaurant-card-icon-row">
        <PaymentCateringIcon />
        <span>
          <span>Средний чек: </span>
          <span :style="{ fontWeight: 700 }"
            >{{ restaurant.averageCheck }} ₽</span
          >
        </span>
      </div>
      <div v-if="restaurant.address" class="restaurant-card-icon-row">
        <LocationCateringIcon />
        <span>{{ restaurant.address }}</span>
      </div>
      <div
        class="restaurant-card-icon-row _schedule"
        @click.stop="openSchedule"
      >
        <TimeCateringIcon />
        <span class="details-tablo">
          {{
            currentDayScheduleInfo[1]
              ? `${getTime(
                  currentDayScheduleInfo[0].workShiftStart.time
                )} — ${getTime(currentDayScheduleInfo[0].workShiftEnd.time)}`
              : "Закрыто"
          }}
        </span>
        <IconSelectArrow
          class="details-tablo-arrow"
          color="#F18E35"
          :style="{ transform: isSchedule ? 'rotate(180deg)' : '' }"
        />
      </div>
      <div
        v-if="restaurant.cuisines && restaurant.cuisines.length"
        class="restaurant-card-icon-row"
      >
        <CuisineCateringIcon />
        <span
          class="restaurant-card-cuisines"
          :class="{
            _short: isTextHidden && isTextLong,
          }"
          @click.stop="setTextHidden(false)"
        >
          {{ trimmedText }}
        </span>
        <span
          v-if="!isTextHidden"
          @click.stop="setTextHidden(true)"
          :style="{ color: '#F18E35', cursor: 'pointer' }"
        >
          Свернуть
        </span>
      </div>
    </div>
    <perfect-scrollbar
      class="restaurant-card-pills"
      v-if="restaurant.specificities && restaurant.specificities.length"
    >
      <div v-for="feature in restaurant.specificities" :key="feature">
        {{ getFeature(feature) }}
      </div>
    </perfect-scrollbar>
    <div
      class="restaurant-card-schedule-wrapper"
      v-if="breakfast || businessLunch"
    >
      <div v-if="breakfast">
        <span class="restaurant-card-schedule-label">Завтраки</span>
        <span class="restaurant-card-schedule-value">
          <TimeCateringIcon /> <span> {{ breakfast }}</span>
        </span>
      </div>
      <div v-if="businessLunch">
        <span class="restaurant-card-schedule-label">Бизнес-ланч</span>
        <span class="restaurant-card-schedule-value">
          <TimeCateringIcon /> <span> {{ businessLunch }}</span>
        </span>
      </div>
    </div>
    <perfect-scrollbar
      v-if="restaurant.images && restaurant.images.length"
      class="restaurant-card-images"
    >
      <VImage
        v-for="(photo, index) in restaurant.images"
        :key="photo"
        :src="photo"
        @click.stop="openModal(restaurant.images, index)"
        class="restaurant-card-image"
      />
    </perfect-scrollbar>
    <div class="restaurant-card-bottom-btns">
      <VButton
        class="restaurant-card-book-button"
        @click.stop="book"
        :disabled="isDisabled"
        outline
      >
        Забронировать стол
      </VButton>
      <IconEmptyFavorite
        v-if="role === 'CLIENT'"
        class="restaurant-card-favorite-btn"
        :color="isFav ? '#F18E35' : '#fff'"
        @click.stop="favoriteToggle"
      />
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/js/api/api";
import Logo from "@/assets/images/logo.png";
import VImage from "@/components/ui/VImage.vue";
import SwiperModal from "@/components/modals/SwiperModal.vue";
import VStars from "@/components/ui/VStars.vue";
import { CUISINES, FEATURES, RESTAURANT_TYPES } from "@/assets/js/utils/consts";
import {
  convertFromNumberToTime,
  formatTime,
  getTimeZone,
  getTodayCateringScheduleInfo,
} from "@/assets/js/utils/helpers";
import LocationCateringIcon from "@/components/icons/cateringCard/LocationCateringIcon.vue";
import TimeCateringIcon from "@/components/icons/cateringCard/TimeCateringIcon.vue";
import VButton from "@/components/ui/VButton.vue";
import PaymentCateringIcon from "@/components/icons/cateringCard/PaymentCateringIcon.vue";
import CuisineCateringIcon from "@/components/icons/cateringCard/CuisineCateringIcon.vue";
import IconEmptyFavorite from "@/components/icons/IconEmptyFavorite.vue";
import "swiper/css/bundle";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import IconSelectArrow from "@/components/icons/IconSelectArrow.vue";
import ScheduleModal from "@/components/modals/ScheduleModal.vue";

export default {
  name: "RestaurantCardMobile",
  components: {
    IconSelectArrow,
    IconEmptyFavorite,
    CuisineCateringIcon,
    PaymentCateringIcon,
    VButton,
    TimeCateringIcon,
    LocationCateringIcon,
    VStars,
    VImage,
    PerfectScrollbar,
  },

  props: ["restaurant"],

  data() {
    return {
      businessLunch: "",
      breakfast: "",
      swiper: null,
      defaultLogo: Logo,
      cuisines: "",
      isTextHidden: true,
    };
  },

  methods: {
    formatTime,
    setTextHidden(value) {
      if (this.isTextLong) {
        this.isTextHidden = value;
      }
    },
    openSchedule() {
      this.$store.dispatch("openModal", {
        value: {
          component: ScheduleModal,
          props: {
            workingTime: this.restaurant.workingTime || [],
          },
        },
      });
    },
    async favoriteToggle() {
      try {
        await API.business.catering.addFavorite({
          catId: this.clickedCatering,
        });

        let favCats = this.$store.state.restaurants.favRestaurants;

        if (this.isFav) {
          favCats = this.$store.state.restaurants.favRestaurants.filter(
            (el) => el.catId !== this.clickedCatering
          );
        } else {
          favCats.push({ catId: this.clickedCatering });
        }

        this.$store.commit({
          type: "setFavRestaurants",
          value: favCats,
        });
      } catch (e) {
        console.log(e);
      }
    },
    getTime(val) {
      return convertFromNumberToTime(val).join(":");
    },
    getType(id) {
      return RESTAURANT_TYPES[id];
    },
    getCuisine(value) {
      return CUISINES[value];
    },
    getFeature(value) {
      return FEATURES[value];
    },
    openModal(images, index, isComment) {
      this.$store.dispatch("openModal", {
        value: {
          component: SwiperModal,
          props: {
            images: {
              urls: isComment ? images : images.map((el) => el),
              initIndex: index,
            },
          },
        },
      });
    },
    book() {
      this.$router.push(`/booking/${this.restaurant.id}`);
    },
  },

  computed: {
    city() {
      return this.$store.state.general.city;
    },
    isTextLong() {
      return this.cuisines.length > 68;
    },
    trimmedText() {
      if (!this.isDescriptionHidden) {
        return this.cuisines;
      }
      return this.isDescriptionLong
        ? this.cuisines.slice(0, 68) + "..."
        : this.cuisines;
    },
    currentDayScheduleInfo() {
      return getTodayCateringScheduleInfo(
        this.restaurant.workingToday,
        getTimeZone(this.city.city)
      );
    },
    isDisabled() {
      if (this.restaurant.scheme && this.restaurant.available) {
        return !(!this.isAuth || this.role === "CLIENT");
      } else {
        return true;
      }
    },
    role() {
      return this.$store.getters.role;
    },
    isFav() {
      return !!this.$store.state.restaurants.favRestaurants.find(
        (el) => el.catId === this.restaurant.id
      );
    },
  },

  async mounted() {
    if (this.restaurant.cuisines?.length) {
      this.cuisines = this.restaurant.cuisines
        .map((item) => this.getCuisine(item))
        .join(", ");
    }
    if (
      this.restaurant.breakfastTime?.Start ||
      this.restaurant.breakfastTime?.End
    ) {
      this.breakfast = `${this.formatTime(
        this.restaurant.breakfastTime.Start
      )} - ${this.formatTime(this.restaurant.breakfastTime.End)}`;
    }
    if (this.restaurant.lunchTime?.Start || this.restaurant.lunchTime?.End) {
      this.businessLunch = `${this.formatTime(
        this.restaurant.lunchTime.Start
      )} - ${this.formatTime(this.restaurant.lunchTime.End)}`;
    }
  },
};
</script>

<style lang="scss" scoped>
.restaurant-card {
  &-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    height: fit-content;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #00000014;
  }

  &-column {
    display: flex;
    flex-direction: column;

    &._right {
      gap: 8px;

      font-size: 14px;
      line-height: 20px;

      .restaurant-card-icon-row {
        display: flex;
        align-items: center;
        gap: 4px;

        &._schedule {
          width: fit-content;
        }

        svg {
          width: 20px;
          height: 20px;
        }

        .details-tablo-arrow {
          width: 10px;
          height: 6px;
          margin-left: 8px;
        }
      }
    }
  }

  &-default-logo {
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    margin-right: 8px;
    border-radius: 50%;
    background-color: #ebebeb;
    background-size: 30px 30px;
    background-repeat: no-repeat;
    filter: grayscale(1);
  }

  &-logo {
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    margin-right: 8px;
    border-radius: 50%;
  }

  &-images {
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;
    padding-bottom: 12px;
  }

  &-image {
    width: 260px;
    height: 160px;
    border-radius: 8px;
  }

  &-cuisines {
    &._short {
      cursor: pointer;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      position: relative;
      line-height: 20px;
      max-height: calc(20px * 3);

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
        pointer-events: none;
      }
    }
  }

  &-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }

  &-header {
    display: flex;
  }

  &-header-row {
    display: flex;
    flex-direction: column;
  }

  &-pills {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;
    padding-bottom: 11px;

    div {
      flex: 0 0 auto;
      padding: 4px 12px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #f18e35;
      border-radius: 8px;
      user-select: none;
    }
  }

  &-bottom-btns {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &-favorite-btn {
    width: 26px;
    height: 24px;
    cursor: pointer;
  }

  &-book-button {
    width: 180px;
    margin-top: auto;
  }

  &-features {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    span {
      margin-bottom: 12px;

      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
    }
  }
}

.restaurant-info {
  display: flex;
  gap: 12px;

  &-item {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #858585;
  }

  &-value {
    font-weight: 600;
    color: #222222;
  }
}

.restaurant-card-top-actions {
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 16px;
}

.restaurant-card-schedule-wrapper {
  display: flex;
  gap: 32px;
}

.restaurant-card-schedule {
  display: flex;
  flex-direction: column;
  gap: 4px;
  &-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
  &-value {
    display: flex;
    align-items: center;
    gap: 4px;

    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.stars {
  :deep(span) {
    font-size: 18px;
    line-height: 24px;
  }
  :deep(svg) {
    width: 24px;
    height: 24px;
  }
}
</style>
